import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SupplierResellerView } from 'Core/models';
import { Uuid } from 'Core/types';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable, Subject } from 'rxjs';
import { SocketService } from './socket.service';

@Injectable({ providedIn: 'root' })
export class SocketEventHandlerService {
  private readonly socketService: SocketService = inject(SocketService);
  private readonly notificationService: NzNotificationService = inject(NzNotificationService);
  private readonly destroyRef: DestroyRef = inject(DestroyRef);

  private readonly supplierResellerChanged$ = new Subject<void>();
  public readonly onSupplierResellerChanged: Observable<void> = this.supplierResellerChanged$.asObservable();

  public init(): void {
    this.listenSupplierResellerEvents();
  }

  private listenSupplierResellerEvents(): void {
    this.socketService
      .on<SupplierResellerView>('supplier-reseller:created')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.notificationService.info('', 'Новая заявка на связь');
        this.supplierResellerChanged$.next();
      });

    this.socketService
      .on<SupplierResellerView>('supplier-reseller:updated')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.notificationService.info('', `Статус заявки изменён: ${data.status}`);
        this.supplierResellerChanged$.next();
      });

    this.socketService
      .on<{ id: Uuid }>('supplier-reseller:deleted')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.notificationService.info('', 'Связь удалена');
        this.supplierResellerChanged$.next();
      });
  }
}
